import { useContext, useState } from "react";
import type { Patient } from "../app-patient/_objects-patient";
import { AuthContext } from "../auth-context";
import { RequestContext } from "../request-context";
import { requestGet } from "../utils/network";
import { Modes } from "../widget/io-abstract";
import IOList from "../widget/io-list";
import IONumber from "../widget/io-number";
import IOString from "../widget/io-string";
import SearchPanel, { getPrefs, type FormValues } from "../widget/search-panel";
import TablePanel from "../widget/table-panel";

export default function PatientsSearch(): React.ReactNode {
  const authenticationContext = useContext(AuthContext)!;
  const requestContext = useContext(RequestContext)!;
  const [lastFormValues, setLastFormValues] = useState<FormValues>(
    getPrefs({
      examiner: authenticationContext.authenticatedData?.user.username || ""
    })
  );

  const onSearch = (data: FormValues): Promise<React.ReactNode> => {
    setLastFormValues(data);
    return requestContext
      .fetchJSONAndMessage<Patient[]>(
        "Searching patient folders",
        requestGet("/api/patient", data)
      )
      .then((response) => response ?? [])
      .then((list) => {
        return (
          <TablePanel<Patient>
            rows={list}
            headers={
              <thead>
                <tr>
                  <th></th>
                  <th>Entry Number</th>
                  <th>Name</th>
                  <th>Sex</th>
                  <th>Year of Birth</th>
                  <th>Phone</th>
                  <th>Pathology</th>
                </tr>
              </thead>
            }
            lineLink={(patient) => `/patient/${patient.id}`}
            lineColumns={(patient) => (
              <>
                <td>
                  {patient.entry_year}-{patient.entry_order}
                </td>
                <td>{patient.name}</td>
                <td>{patient.sex}</td>
                <td>{patient.year_of_birth}</td>
                <td>{patient.phone}</td>
                <td>{patient.pathology}</td>
              </>
            )}
            reportBasename="patients"
          />
        );
      });
  };

  return (
    <div>
      <h1>
        <img src="/static/img/patientsSearch.gif" />
        Search for a patient
      </h1>

      <SearchPanel
        form={
          <>
            <IONumber
              name="entry_year"
              mode={Modes.input}
              value={
                lastFormValues["entry_year"]
                  ? Number(lastFormValues["entry_year"])
                  : undefined
              }
            />
            <IONumber
              name="entry_order"
              mode={Modes.input}
              value={
                lastFormValues["entry_order"]
                  ? Number(lastFormValues["entry_order"])
                  : undefined
              }
            />
            <IOString
              name="name"
              mode={Modes.input}
              value={lastFormValues["name"]}
            />
            <IOList
              name="sex"
              mode={Modes.input}
              list={authenticationContext.getList("sex")}
              value={lastFormValues["sex"]}
            />
            <IOString
              name="year_of_birth"
              mode={Modes.input}
              value={lastFormValues["year_of_birth"]}
            />
            <IOString
              name="phone"
              mode={Modes.input}
              value={lastFormValues["phone"]}
            />
            <IOList
              name="pathology"
              mode={Modes.input}
              list={authenticationContext.getList("Pathologies")}
              value={lastFormValues["pathology"]}
            />
          </>
        }
        onSearch={onSearch}
      />
    </div>
  );
}
